const analyticsEventNames = {
  artifactDownloadButtonClicked: 'Artifact Download Button Clicked',
  artifactInstallButtonClicked: 'Artifact Install Button Clicked',
};

export default analyticsEventNames;
